import apis from "../../core/apis.js";

class HolidayResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.holiday).get(options);
  }

  get(id) {
    return this.$resource(apis.holiday + id).get();
  }

  search(search = "") {
    return this.$resource(apis.holiday).get({ search });
  }

  post(item) {
    return this.$resource(apis.holiday).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.holiday + id + `/${name}`).save(item);
  }
}

export default HolidayResource;



// WEBPACK FOOTER //
// ./src/resources/holiday/holiday.resource.js